import { BrowserDetect, isMobile } from '../thirdparty/browser_detect.js';

function stickyNavbarFunc (navbar) {
    let offset = 0;
    let sticky = false;
    let windowTop = $(window).scrollTop();

    if ( navbar.offset().top == windowTop) {
        $('body').addClass("navbar-sticky");
        sticky = true;
    }
    else {
        $('body').removeClass("navbar-sticky");
    }
}

export default function () {

    console.log('init stickyNavbar');

    let navbar = $('#wrapper-navbar');

    if ( ! isMobile.any() ) {
        $('body').on('touchmove', function(e) { 
            stickyNavbarFunc(navbar);
        });
    }
    else {
        $(window).on('scroll', () => {
            stickyNavbarFunc(navbar);
        });
    }
    
}